import { VitalSignsScreen } from "app/screens/residents/show/VitalSignsScreen";

export default function VitalSignsPage() {
  return <VitalSignsScreen />;
}
